







import { defineComponent, onMounted, computed, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { CONSTANT_URL } from '@/renderer/scripts/http';

export default defineComponent({
  name: 'FeatureMask',
  props: {
    tips: {
      type: String,
      default: i18n_t('升级企业版可用'),
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const isShow = computed(() => context.root.$store.getters.editionFlag !== 'enterprise');
    isShow &&
      reporter.report('pay', {
        pay_source_show: 'WeCom_limit',
      });
    context.root.$store.commit('setPaySource', 'WeCom_limit');
    const methods = {
      goUpgrade() {
        // 打开腾讯云工单页
        dispatchRouter(CONSTANT_URL.consoleBillUrl);
      },
    };
    onMounted(() => {
      // 原理是先找到父元素，然后给兄弟元素除了自己加上模糊效果
      const ele: any = context.refs.mask;
      if (ele && ele.parentNode) {
        ele.parentNode.className += ' feature-not-supported__parent-content';
      }
    });
    return {
      ...methods,
    };
  },
});
